<template>
  <div class="w-full">
    <div class="w-full flex justify-content-center">
      <DeferredContent v-if="item?.pdf" class="surface-100 py-0 w-9">
        <div class="w-full">
          <embed
            class="w-full"
            :src="external ? item.pdf : `/media/${item.pdf}.pdf`"
            height="800"
            type="application/pdf"
          />
        </div>
      </DeferredContent>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  external: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss">
/* Add your styles here */
</style>
